export function secretPrizeExpired() {
  const expires = new Date(process.env.REACT_APP_SECRET_PRIZE_EXPIRE_DATE);
  return expires.getTime() < new Date().getTime();
}

export default secretPrizeExpired;
